import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import CurrencyInput from 'src/components/formik-fields/currency-input/CurrencyInput';
import BasicInput from 'src/components/formik-fields/basic-input/BasicInput';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import FormatService from 'src/services/format.service';
import { AddAccountFormViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import ManualAccountService from 'src/services/manualAccount.service';

import colors from 'src/styles/colors.module.scss';
import styles from '../../addAccountFormContainer.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import DefaultFormButtons from '../../defaultFormButtons/DefaultFormButtons';
import { InvestmentHoldingType } from 'src/types/investment-holding.model';

/** This component does not use AddAccountForm because it requires access to the form values for rendering */
export default function PrivateStockForm({
    manualAccount,
    onSubmit,
    handleBack
}: AddAccountFormViewModel): JSX.Element {
    const secondaryOnclick = (): void => {
        void ManualAccountService.deleteAccount(manualAccount);
        handleBack();
    };
    return (
        <Formik
            initialValues={{
                ...{
                    name: '',
                    price: '',
                    quantity: ''
                },
                ...manualAccount?.investmentHolding
            }}
            validationSchema={Yup.object({
                name: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                price: Yup.number()
                    .required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull'))
                    .typeError(LiteralsService.getLiteral('Onboarding.forms.inputValidationTypeNumber')),
                quantity: Yup.number().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull'))
            })}
            onSubmit={(values) => {
                void onSubmit(values, manualAccount, false, InvestmentHoldingType.PrivateStock);
            }}
        >
            {({ values }) => {
                return (
                    <Form className={styles.form}>
                        <BasicInput id="name" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.name')} />
                        <CurrencyInput
                            id="price"
                            label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.price')}
                        />
                        <BasicInput
                            id="quantity"
                            label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.quantity')}
                        />
                        {values.price && values.quantity && (
                            <div>
                                <Typography variant={TypographyVariants.BODY_BOLD}>
                                    {LiteralsService.getLiteral('Onboarding.forms.total')}
                                </Typography>
                                <Typography variant={TypographyVariants.HEADING_XL} className={colors.textStrong}>
                                    {FormatService.format(Number(values.price) * Number(values.quantity))}
                                </Typography>
                            </div>
                        )}
                        <DefaultFormButtons update={!!manualAccount} secondaryOnclick={secondaryOnclick} />
                    </Form>
                );
            }}
        </Formik>
    );
}
